import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Seguimiento/addMultiSeguimiento`, method: 'POST', body: values, token: token})
}
